module.exports = __webpack_public_path__ + "static/media/ComputerVisionReact.e26588af.png";